import axios from 'axios';
import { client } from '@/services/api/axios.ts';
import { useMutation } from '@tanstack/react-query';

type TPostRegister = {
  code: string;
  email: string;
};

async function confirmEmail({
  code,
  email,
}: TPostRegister): Promise<{ message: string } | undefined | void> {
  try {
    const { data } = await client.post('/auth/confirm-email', {
      code,
      email,
    });

    return data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      throw new Error(`${error?.response?.data?.message}`);
    }

    if (error instanceof Error) {
      throw new Error(`${error.message}}`);
    }
  }
}

export const useConfirmEmailQuery = ({ onSuccess }: { onSuccess: () => void }) => {
  return useMutation({
    mutationFn: confirmEmail,
    onSuccess: () => {
      if (onSuccess) onSuccess();
    },
  });
};
